/* ============================================================
   PLUVION — Custom JavaScript
   Dawn Theme Enhancement
   ============================================================ */

(function () {
  'use strict';

  /* ─── Scroll Animations ─────────────────────────────────── */
  function initScrollAnimations() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    document.querySelectorAll('.animate-fade-up').forEach((el) => {
      observer.observe(el);
    });
  }

  /* ─── Sticky Header ─────────────────────────────────────── */
  function initStickyHeader() {
    const header = document.querySelector('.header-wrapper');
    if (!header) return;

    window.addEventListener(
      'scroll',
      () => {
        if (window.scrollY > 80) {
          header.classList.add('scrolled');
        } else {
          header.classList.remove('scrolled');
        }
      },
      { passive: true }
    );
  }

  /* ─── Testimonials Carousel (mobile) ───────────────────── */
  function initTestimonialsCarousel() {
    const grid = document.querySelector('.pluvion-testimonials__grid');
    if (!grid || window.innerWidth > 768) return;

    let currentIndex = 0;
    const cards = grid.querySelectorAll('.pluvion-testimonials__card');
    const total = cards.length;

    if (total <= 1) return;

    // Show only current card on mobile
    function updateCarousel() {
      cards.forEach((card, i) => {
        card.style.display = i === currentIndex ? 'block' : 'none';
      });
    }

    // Add navigation dots
    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'pluvion-testimonials__dots';
    dotsContainer.style.cssText =
      'display:flex;justify-content:center;gap:0.5rem;margin-top:2rem;';

    for (let i = 0; i < total; i++) {
      const dot = document.createElement('button');
      dot.style.cssText =
        'width:8px;height:8px;border-radius:50%;border:none;cursor:pointer;transition:background 0.3s;background:' +
        (i === 0 ? '#e8c47a' : 'rgba(250,247,244,0.3)') +
        ';';
      dot.addEventListener('click', () => {
        currentIndex = i;
        updateCarousel();
        updateDots();
      });
      dotsContainer.appendChild(dot);
    }

    function updateDots() {
      dotsContainer.querySelectorAll('button').forEach((dot, i) => {
        dot.style.background =
          i === currentIndex ? '#e8c47a' : 'rgba(250,247,244,0.3)';
      });
    }

    grid.after(dotsContainer);
    updateCarousel();

    // Auto-advance
    setInterval(() => {
      currentIndex = (currentIndex + 1) % total;
      updateCarousel();
      updateDots();
    }, 4500);
  }

  /* ─── Smooth Scroll for Anchor Links ───────────────────── */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener('click', function (e) {
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ─── Product Image Zoom ────────────────────────────────── */
  function initImageZoom() {
    document.querySelectorAll('.product__media img').forEach((img) => {
      img.addEventListener('mousemove', function (e) {
        const rect = this.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        this.style.transformOrigin = x + '% ' + y + '%';
        this.style.transform = 'scale(1.35)';
        this.style.transition = 'transform 0.1s ease';
      });

      img.addEventListener('mouseleave', function () {
        this.style.transform = 'scale(1)';
        this.style.transition = 'transform 0.4s ease';
      });
    });
  }

  /* ─── Announcement Bar Marquee ──────────────────────────── */
  function initAnnouncementScroll() {
    const bar = document.querySelector('.announcement-bar__message');
    if (!bar) return;

    const parent = bar.parentElement;

    // Only activate marquee when text overflows the bar
    if (bar.scrollWidth <= parent.offsetWidth) return;

    parent.classList.add('announcement-bar__message--marquee');

    // Clone for seamless loop
    const clone = bar.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    parent.appendChild(clone);
  }

  /* ─── Init All ──────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', () => {
    initScrollAnimations();
    initStickyHeader();
    initTestimonialsCarousel();
    initSmoothScroll();
    initImageZoom();
    initAnnouncementScroll();
    initProductPage();
    initViewersCount();
    initAtcLoading();
  });

  /* ─── Re-init on Shopify section updates ──────────────── */
  document.addEventListener('shopify:section:load', () => {
    initScrollAnimations();
    initProductPage();
    initViewersCount();
    initAtcLoading();
  });

  /* ─── Product Page ──────────────────────────────────── */
  function formatMoney(cents) {
    return '\u20AC\u00a0' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function initProductPage() {
    const section = document.querySelector('.pluvion-product');
    if (!section) return;

    const sid = section.dataset.sectionId;
    const mainImg = document.getElementById('pluvion-main-img-' + sid);
    const thumbs = section.querySelectorAll('.pluvion-product__thumb');
    const qtyInput = document.getElementById('pluvion-qty-' + sid);
    const atcBtn = document.getElementById('pluvion-atc-' + sid);
    const variantIdInput = document.getElementById('pluvion-variant-id-' + sid);
    const priceEl = document.getElementById('pluvion-price-' + sid);
    const stockEl = document.getElementById('pluvion-stock-' + sid);
    const stickyAtc = document.getElementById('pluvion-sticky-atc-' + sid);
    const stickyPriceEl = document.getElementById('pluvion-sticky-price-' + sid);
    const stickyBtn = document.getElementById('pluvion-sticky-btn-' + sid);
    const productInfoEl = document.getElementById('pluvion-product-info-' + sid);

    // ── Gallery thumbnails ──
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg) return;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        this.classList.add('is-active');
        mainImg.src = this.dataset.imageSrc;
        mainImg.srcset = this.dataset.imageSrcset;
        mainImg.alt = this.dataset.imageAlt;
      });
    });

    // ── Quantity stepper ──
    section.querySelectorAll('.pluvion-product__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var current = parseInt(qtyInput.value, 10) || 1;
        if (this.dataset.action === 'plus') {
          qtyInput.value = current + 1;
        } else if (this.dataset.action === 'minus' && current > 1) {
          qtyInput.value = current - 1;
        }
      });
    });

    // ── Variant selection ──
    var variantDataEl = document.getElementById('pluvion-product-variants-' + sid);
    if (variantDataEl && variantIdInput) {
      var variants = [];
      try { variants = JSON.parse(variantDataEl.textContent); } catch (e) {}

      function getOptionValues() {
        var values = [];
        section.querySelectorAll('.pluvion-product__option').forEach(function (optionEl) {
          var select = optionEl.querySelector('.pluvion-product__select');
          var checkedRadio = optionEl.querySelector('.pluvion-product__color-input:checked');
          if (checkedRadio) {
            values.push(checkedRadio.value);
          } else if (select) {
            values.push(select.value);
          }
        });
        return values;
      }

      function findVariant(optionValues) {
        return variants.find(function (v) {
          return optionValues.every(function (opt, i) {
            return v['option' + (i + 1)] === opt;
          });
        });
      }

      function updateVariantUI(variant) {
        if (!variant) return;

        // Hidden ID
        variantIdInput.value = variant.id;

        // URL
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }

        // Price
        if (priceEl) {
          if (variant.compare_at_price > variant.price) {
            priceEl.innerHTML =
              '<span class="pluvion-product__price--sale">' + formatMoney(variant.price) + '</span>' +
              '<span class="pluvion-product__price--was">' + formatMoney(variant.compare_at_price) + '</span>' +
              '<span class="pluvion-product__price--badge">SALE</span>';
          } else {
            priceEl.innerHTML =
              '<span class="pluvion-product__price--regular">' + formatMoney(variant.price) + '</span>';
          }
        }

        // Sticky price
        if (stickyPriceEl) {
          stickyPriceEl.textContent = formatMoney(variant.price);
        }

        // Stock
        var dotIn = '<span class="pluvion-product__stock-dot pluvion-product__stock-dot--in"></span>';
        var dotOut = '<span class="pluvion-product__stock-dot pluvion-product__stock-dot--out"></span>';
        var stockLabel = section.dataset.stockLabel || 'Op voorraad \u2014 levering binnen 1\u20132 werkdagen';
        if (stockEl) {
          stockEl.innerHTML = variant.available
            ? dotIn + '<span>' + stockLabel + '</span>'
            : dotOut + '<span>Tijdelijk uitverkocht</span>';
        }

        // ATC button
        var ctaLabel = section.dataset.ctaLabel || 'In winkelwagen';
        if (atcBtn) {
          atcBtn.disabled = !variant.available;
          atcBtn.textContent = variant.available ? ctaLabel : 'Uitverkocht';
        }

        // Color swatch selected state
        section.querySelectorAll('.pluvion-product__option').forEach(function (optionEl, i) {
          var swatches = optionEl.querySelectorAll('.pluvion-product__color-swatch');
          swatches.forEach(function (swatch) {
            var radio = swatch.querySelector('.pluvion-product__color-input');
            if (radio) {
              swatch.classList.toggle('is-selected', radio.checked);
            }
          });
        });
      }

      // Bind selects
      section.querySelectorAll('.pluvion-product__select').forEach(function (sel) {
        sel.addEventListener('change', function () {
          updateVariantUI(findVariant(getOptionValues()));
        });
      });

      // Bind color radios
      section.querySelectorAll('.pluvion-product__color-input').forEach(function (radio) {
        radio.addEventListener('change', function () {
          updateVariantUI(findVariant(getOptionValues()));
        });
      });
    }

    // ── Sticky ATC visibility ──
    if (stickyAtc && productInfoEl) {
      var stickyObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              stickyAtc.classList.add('is-visible');
              stickyAtc.removeAttribute('aria-hidden');
            } else {
              stickyAtc.classList.remove('is-visible');
              stickyAtc.setAttribute('aria-hidden', 'true');
            }
          });
        },
        { threshold: 0.05 }
      );
      stickyObserver.observe(productInfoEl);

      // Sticky button click → submit main form
      if (stickyBtn && atcBtn) {
        stickyBtn.addEventListener('click', function () {
          atcBtn.click();
        });
      }
    }

    // ── FAQ accordion ──
    section.querySelectorAll('.pluvion-product__faq-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isOpen = this.getAttribute('aria-expanded') === 'true';
        var faqItem = this.closest('.pluvion-product__faq-item');
        var answer = faqItem.querySelector('.pluvion-product__faq-a');
        var icon = this.querySelector('.pluvion-product__faq-icon');

        // Close all others
        section.querySelectorAll('.pluvion-product__faq-q').forEach(function (other) {
          if (other !== btn) {
            other.setAttribute('aria-expanded', 'false');
            var otherAnswer = other.closest('.pluvion-product__faq-item').querySelector('.pluvion-product__faq-a');
            var otherIcon = other.querySelector('.pluvion-product__faq-icon');
            if (otherAnswer) otherAnswer.hidden = true;
            if (otherIcon) otherIcon.textContent = '+';
          }
        });

        // Toggle this one
        this.setAttribute('aria-expanded', String(!isOpen));
        answer.hidden = isOpen;
        icon.textContent = isOpen ? '+' : '\u2212';
      });
    });
  }

  /* ─── Viewers social proof ──────────────────────────────── */
  function initViewersCount() {
    document.querySelectorAll('.pluvion-product__urgency-count').forEach(function (el) {
      var min = parseInt(el.dataset.min, 10) || 11;
      var max = parseInt(el.dataset.max, 10) || 34;
      var count = Math.floor(Math.random() * (max - min + 1)) + min;
      el.textContent = count;

      // Subtle fluctuation every 20–45s
      setInterval(function () {
        var delta = Math.random() < 0.5 ? -1 : 1;
        count = Math.max(min, Math.min(max, count + delta));
        el.textContent = count;
      }, (Math.random() * 25000) + 20000);
    });
  }

  /* ─── ATC loading state ─────────────────────────────────── */
  function initAtcLoading() {
    document.querySelectorAll('.pluvion-product__atc').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        btn.classList.add('is-loading');
        setTimeout(function () {
          btn.classList.remove('is-loading');
        }, 1800);
      });
    });
  }

})();


// SWATCH-IMAGE-SWITCHER-V1
(function () {
  function scoreFilenameForColor(filename, colorName) {
    var norm = colorName.toLowerCase().replace(/\s+/g, '');
    var words = colorName.toLowerCase().split(/\s+/);
    var base = filename.toLowerCase().replace(/\.[^.]+$/, '');
    var parts = base.split('-');

    // Score 3: exact normalized color appears as a standalone filename segment
    if (parts.indexOf(norm) !== -1) return 3;

    // Score 2: all color words appear individually as filename segments
    var allMatch = words.every(function(w) { return parts.indexOf(w) !== -1; });
    if (allMatch) return 2;

    // Score 1.5: normalized color is a substring of the full filename
    if (base.indexOf(norm) !== -1) return 1.5;

    // Score 1: first word of color appears as a filename segment
    if (parts.indexOf(words[0]) !== -1) return 1;

    // Score 0.5: first word of color appears anywhere in the base
    if (base.indexOf(words[0]) !== -1) return 0.5;

    return 0;
  }

  function switchGalleryToColor(colorValue) {
    var thumbs = document.querySelectorAll('.pluvion-product__thumb');
    if (!thumbs.length) return;

    var bestThumb = null;
    var bestScore = 0;

    thumbs.forEach(function (thumb) {
      var src = thumb.getAttribute('data-image-src') || '';
      var filename = src.split('/').pop().split('?')[0];
      var score = scoreFilenameForColor(filename, colorValue);
      if (score > bestScore) {
        bestScore = score;
        bestThumb = thumb;
      }
    });

    if (bestThumb && bestScore > 0) {
      bestThumb.click();
    }
  }

  function initSwatchSwitcher() {
    // Listen for clicks on the swatch labels
    var swatchLabels = document.querySelectorAll('.pluvion-product__color-swatch');
    swatchLabels.forEach(function (label) {
      label.addEventListener('click', function () {
        var radio = this.querySelector('input[type="radio"]');
        if (!radio) return;
        var val = radio.value;
        // Slight delay so the radio is checked before we read its value
        setTimeout(function () { switchGalleryToColor(val); }, 10);
      });
    });

    // Also catch radio change events directly (keyboard navigation, etc.)
    var radios = document.querySelectorAll('.pluvion-product__color-swatches input[type="radio"]');
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (this.checked) switchGalleryToColor(this.value);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwatchSwitcher);
  } else {
    initSwatchSwitcher();
  }
}());
